import { styled } from "@mui/material/styles";
import InputBase from "@mui/material/InputBase";
import Box from "@mui/material/Box";
import FormControl from "@mui/material/FormControl";
import { Stack, Typography } from "@mui/material";

const BootstrapInput = styled(InputBase)(({ theme }) => ({
    "& .MuiInputBase-input": {
        borderRadius: 4,
        height: 12,
        position: "relative",
        backgroundColor: theme.palette.mode === "light" ? "#FFFFFF" : "#1A2027",
        border: "1px solid",
        borderColor: theme.palette.mode === "light" ? "#C6C6C6" : "#2D3843",
        fontSize: 12,
        padding: "10px 12px",
        transition: theme.transitions.create([
            "border-color",
            "background-color",
            "box-shadow",
        ]),
        fontFamily: [
            "-apple-system",
            "BlinkMacSystemFont",
            '"Segoe UI"',
            "Roboto",
            '"Helvetica Neue"',
            "Arial",
            "sans-serif",
            '"Apple Color Emoji"',
            '"Segoe UI Emoji"',
            '"Segoe UI Symbol"',
        ].join(","),
        "&:focus": {
            // boxShadow: `${alpha(theme.palette.primary.main, 0.25)} 0 0 0 0.2rem`,
            borderColor: "var(--bgGreenPrimary)",
        },
    },
}));

export default function TextInput({
    defaultValue = "",
    id = "",
    placeholder = "",
    type = "text",
    register,
    disabled = false,
    require = false,
    readOnly = false,
    rules = {},
    errors,
    helperText = "",
}) {
    return (
        <>
            <FormControl error={!!errors} fullWidth variant="standard">
                <BootstrapInput
                    autoComplete="off"
                    type={type}
                    required={require}
                    disabled={disabled}
                    readOnly={readOnly}
                    defaultValue={defaultValue}
                    id={id}
                    placeholder={placeholder}
                    error={!!errors}
                     helperText={errors?.message}
                    inputProps={{
                        "aria-describedby": `${id}-helper-text`,
                    }}
                    {...register(id ? id : "name", { ...rules })}
                />
                {errors && (
                    <Box
                        component="span"
                        id={`${id}-helper-text`}
                        sx={{
                            color: "#b30000",
                            fontSize: 11,
                            marginTop: 0.5,
                            whiteSpace: "wrap",
                            maxWidth: 200,
                        }}
                    >
                        {errors?.message}
                    </Box>
                )}
            </FormControl>
        </>
    );
}

